import { useEffect, useRef } from 'react';
import { useAppState } from '../context/useAppState';
import { useForecast } from '../context/useForecast';

export function useAutoSave() {
  const { state } = useAppState();
  const { saveNow, canWrite } = useForecast();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    // Lecture seule → on ne déclenche aucune sauvegarde.
    if (!canWrite) return;

    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      saveNow();
    }, 500);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [state, canWrite]);
}
